export function formatLcp(lcp) {
  const value = Number(lcp);

  if (!Number.isFinite(value)) {
    return '';
  }

  if (value < 1000) {
    return `${Math.round(value)}ms`;
  }

  return `${(value / 1000).toFixed(1)}s`;
}
